define.alias("ember-cli-string-helpers/helpers/html-safe", "media/helpers/html-safe");